import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import ScrollToTop from "@/components/ScrollToTop";
import { BLOG_POSTS } from "@/lib/data";
import { ArrowRight } from "lucide-react";

export default function BlogListPage() {
  React.useEffect(() => {
    document.title = "Travel Guides — Nandi Hills Weekend Getaways | Mrinmaya vacation home";
  }, []);

  return (
    <div className="bg-mrn-bg min-h-screen" data-testid="blog-list-page">
      <Header />
      <main className="pt-32 pb-24">
        <section className="max-w-7xl mx-auto px-6 md:px-10">
          <p className="text-xs uppercase tracking-[0.3em] text-mrn-terracotta font-medium">
            The Mrinmaya Journal
          </p>
          <h1 className="mt-4 headline-display text-4xl md:text-6xl text-mrn-wood max-w-3xl">
            Travel guides for <em className="font-light text-mrn-green">Nandi Hills weekends.</em>
          </h1>
          <p className="mt-6 max-w-xl text-mrn-wood-soft">
            Locally-written notes on sunrise timings, Skandagiri treks, Isha Foundation visits
            and slow weekend itineraries from Bangalore.
          </p>

          <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {BLOG_POSTS.map((p, i) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                data-testid={`post-card-${i}`}
                className="group"
              >
                <div className="overflow-hidden rounded-2xl">
                  <img
                    src={p.cover}
                    alt={p.title}
                    className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="pt-5">
                  <div className="text-xs uppercase tracking-widest text-mrn-terracotta">
                    {p.date} · {p.readTime}
                  </div>
                  <h3 className="mt-3 font-display text-2xl text-mrn-wood leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm text-mrn-wood-soft">{p.excerpt}</p>
                  <div className="mt-4 inline-flex items-center gap-1 text-mrn-terracotta text-sm font-medium">
                    Read guide <ArrowRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFAB />
      <ScrollToTop />
    </div>
  );
}
